<template>
  <div id="app">
    <router-view />
    <md-button v-if="!modal" to="/add-moment" :md-ripple="false" class="md-icon-button md-raised md-fab c-fab__large">
      <md-icon>add</md-icon>
    </md-button>
    <splashscreen></splashscreen>
  </div>
</template>

<script>
import splashscreen from "./components/SplashScreen";
import { gTagInit } from "./init/analytics.init";
export default {
  name: "App",
  components: {
    splashscreen
  },
  mounted() {
    return gTagInit();
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    modal() {
      if (this.$route && Array.isArray(this.$route.meta)) {
        return this.$route.meta.includes("modal");
      }
      return false;
    }
  },
  data() {
    return {
      menuVisible: false
    };
  }
};
</script>
